import { Button } from '@mui/base';
import { Grid, List, ListItem } from '@mui/material';
import React from 'react';
import { ReactZoomPanPinchRef, TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import { DoorPunch } from '../../icons/doorpunch';


// https://www.npmjs.com/package/react-zoom-pan-pinch
// https://blog.logrocket.com/adding-zoom-pan-pinch-react-web-apps/

/*
interface PlanItem {
    id: string,
    planDocumentId: number,
    planCode: string,
    x: number,
    y: number,
}
    */
interface DoorProps {
    id: string,
    planCode: string,
    x: number,
    y: number;
}

export const Editor = () => {

    const [doors, setDoors] = React.useState<DoorProps[]>([]);
    const [addDoor, setAddDoor] = React.useState<boolean>(false);
    const [scale, setScale] = React.useState(1);

    const onZoom = (ref: ReactZoomPanPinchRef) => {
        setAddDoor(false);
        setScale(ref.state.scale);
    };
    const onPanning = (ref: ReactZoomPanPinchRef) => {
        setAddDoor(false);
        setScale(ref.state.scale);
    };
    /*
        const doorScale = React.useMemo(() => {
            if (scale >= 2) {
                return scale - 1;
            } else {
                return 1;
            }
        }, [scale]);
    */
    const transformComponentRef = React.useRef<ReactZoomPanPinchRef | null>(null);
    const baseContainerRed = React.useRef<HTMLDivElement | null>(null);
    console.log('scale', scale);
    const handleClick = (event: React.MouseEvent<any>) => {
        if (addDoor && baseContainerRed.current) {
            const rect = baseContainerRed.current.getBoundingClientRect();
            const { x, y } = { x: event.clientX - rect.left, y: event.clientY - rect.top };
            console.log('scale', scale);
            console.log('xy', x, y);
            console.log('client', event.clientX, event.clientY);
            console.log('ref', rect.left, rect.top);
            //const { x, y } = { x: event.clientX, y: event.clientY };
            setDoors(p => p.concat([{
                id: crypto.randomUUID(),
                planCode: '',
                x: x * (1 / scale),
                y: y * (1 / scale)
            }]));
        };
    };

    const goto = (index: number) => {
        const elem = document.getElementById('door' + index);
        if (elem && transformComponentRef.current) {
            transformComponentRef.current.zoomToElement(elem, scale);
        }

    };


    return <>
        <h2>TRANFORM ZONE HERE</h2>
        <Grid container>
            <Grid item xs={6}>
                <TransformWrapper
                    minScale={0.2}
                    limitToBounds={false}
                    ref={transformComponentRef}
                    onZoom={onZoom}
                    onPanning={onPanning}>
                    <TransformComponent wrapperStyle={{ width: 500, height: 500 }} contentStyle={{ width: "100%", height: "100%" }}>
                        <div
                            ref={baseContainerRed}
                            onClick={handleClick}
                            onMouseDown={() => setAddDoor(true)}>
                            {doors.map((p, index) => <DoorPunch id={'door' + index} key={index} style={{ position: 'absolute', width: '20px', top: p.y - 10, left: p.x - 10 }} />)}
                            <img src="/assets/bg/cdx_bg_1.jpg" alt="test" />
                        </div>
                    </TransformComponent>
                </TransformWrapper>
            </Grid>
            <Grid item xs={6}>
                <List>
                    {doors.map((p, index) => {
                        return <ListItem key={p.id}>Item {p.id} x = {p.x} y = {p.y} <Button onClick={() => { goto(index); }}>SELECT</Button></ListItem>;
                    })}
                </List>
            </Grid>
        </Grid>
    </>;
};
